export function formatFCFA(n) {
  const v = Math.round(Number(n) || 0);
  return `${v.toLocaleString("fr-FR").replace(/\u202f|,/g, " ")} FCFA`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "—";
  }
}
